import { Component } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../../core/navigation.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../../core/security/user.service';
import { LeftPanelService } from '../../../../../layout/home/services/left-panel.service';
import { DatePickerConfigService } from '../../../../../shared/components/datepicker/datepicker-config.service';


@Component({
  selector: 'lfwms-commodity-search',
  templateUrl: './commodity-secondary-accordian.component.html',
  styleUrls: ['./commodity-secondary-accordian.component.css']
})
export class CommoditySecondaryAccordianComponent extends AbstractFormWidgetComponent {


  public accordionLine2: Array<any> = ['susr1', 'susr2', 'susr3', 'susr4', 'susr5'];
  public accordionLine3: Array<any> = ['ivas', 'ovas', 'busr3', 'busr4'];
  public accordionLine4: Array<any> = ['busr1', 'busr2', 'busr5', 'busr6'];
  public accordionLine5: Array<any> = [ 'busr7', 'busr8', 'busr9', 'busr10'];
  public accordionLine6: Array<any> = ['lottable01Label', 'lottable02Label', 'lottable03Label', 'lottable04Label', 'lottable05Label'];
  public accordionLine7: Array<any> = ['lottable06label', 'lottable07label', 'lottable08label', 'lottable09label', 'lottable10label'];
  public accordionLine8: Array<any> = ['lottable11label', 'lottable12label', 'lottable13label', 'lottable14label', 'lottable15label'];


  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
    super(resourceService, navService, leftPanelService, alertService, userService, dateConfigService);
  }

  protected initializeWidget() {
    super.initializeWidget();
    this.propertyList = this.widgetConfig.propertyList;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/setup/customer/commodity/commodity-secondary-accordian/commodity-secondary-accordian.component.ts